"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var EliminateFilled = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M512 64c247.424 0 448 200.576 448 448S759.424 960 512 960 64 759.424 64 512 264.576 64 512 64zM406.4 346.07a42.667 42.667 0 00-62.827 57.62l2.496 2.71L451.627 512l-105.6 105.6a42.667 42.667 0 0057.642 62.827l2.71-2.496 105.6-105.6 105.6 105.6a42.667 42.667 0 0062.826-57.622l-2.496-2.709L572.31 512l105.6-105.6a42.667 42.667 0 00-57.621-62.827l-2.71 2.496-105.6 105.6-105.6-105.6z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
EliminateFilled.displayName = "EliminateFilled";
var _default = exports["default"] = EliminateFilled;